import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import { FILTER_AVAILABILITY } from 'dpl/constants/query_params';
import {
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';

import FilterPill from './FilterPill';
import MultiSelectChecklistFilter from './MultiSelectChecklistFilter';
import ExposedFilterBottomModal from './ExposedFilterBottomModal';
import ExposedFilterDropdown from './ExposedFilterDropdown';
import MobileFilterButtons from './MobileFilterButtons';

const IS_LT_MD = isLessThanBreakpoint('md');

const FILTER_TITLE = 'Filter results by go home date';

export default function GoHomeDateFilterButton({
  resultsType,
  totalItemCount
}) {
  const { server, queryParams } = useSelector(state => state);
  const { availabilityOptions } = server;
  const isSelected = Boolean(queryParams[FILTER_AVAILABILITY]);
  const [isAvailabilityFilterOpen, setIsAvailabilityFilterOpen] =
    useState(false);

  const analytics = {
    button_cta: 'go home date',
    view: ANALYTICS_VIEWS.PUPPY_SEARCH_RESULTS,
    view_feature: ANALYTICS_VIEW_FEATURES.GO_HOME_DATE_FILTER_BUTTON,
    view_feature_location: ANALYTICS_VIEW_FEATURE_LOCATIONS.SEARCH_HEADER
  };

  const FilterButton = (
    <FilterPill
      onClick={() => setIsAvailabilityFilterOpen(true)}
      label="Go home date"
      prefixIconName="fetch-calendar"
      displayDropdownArrow
      isSelected={isSelected}
      analytics={analytics}
      isOpen={isAvailabilityFilterOpen}
    />
  );

  if (IS_LT_MD) {
    return (
      <>
        {FilterButton}
        <ExposedFilterBottomModal
          isFilterMenuOpen={isAvailabilityFilterOpen}
          setIsFilterMenuOpen={setIsAvailabilityFilterOpen}
          resultsType={resultsType}
          totalItemCount={totalItemCount}
          title={FILTER_TITLE}
        >
          <MultiSelectChecklistFilter
            filterParam={FILTER_AVAILABILITY}
            filterOptions={availabilityOptions}
          />
        </ExposedFilterBottomModal>
      </>
    );
  }

  return (
    <ExposedFilterDropdown
      isOpen={isAvailabilityFilterOpen}
      setIsOpen={setIsAvailabilityFilterOpen}
      toggleButton={FilterButton}
    >
      <MultiSelectChecklistFilter
        filterTitle={FILTER_TITLE}
        filterParam={FILTER_AVAILABILITY}
        filterOptions={availabilityOptions}
      />
      <MobileFilterButtons
        className="mt4"
        setIsMenuOpen={() => setIsAvailabilityFilterOpen(false)}
        totalItemCount={totalItemCount}
        resultsType={resultsType}
      />
    </ExposedFilterDropdown>
  );
}
GoHomeDateFilterButton.propTypes = {
  resultsType: PropTypes.string.isRequired,
  totalItemCount: PropTypes.number.isRequired
};
